module.exports = __webpack_public_path__ + "img/jf_home_02.6a2cdcfb.jpg";